// Shared helpers + constants for room-detail table cells.

export function fmt(val) {
  if (val == null || val === '' || isNaN(val)) return '';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(val));
}

export function fmtTotal(val) {
  if (val == null || isNaN(val)) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(val));
}

export function normalizeUrl(url) {
  if (!url) return '#';
  return url.startsWith('http') ? url : `https://${url}`;
}

export function displayUrl(url) {
  try {
    const u = new URL(normalizeUrl(url));
    return u.hostname.replace('www.', '');
  } catch {
    return url.length > 25 ? url.substring(0, 25) + '...' : url;
  }
}

export const STATUS_OPTIONS = ['Delivered', 'Ordered', 'In Cart', 'Pending', 'Confirmed', 'Returned'];
